<template>
  <Row class="row-item" :gutter="12">
    <Col span="4" class="col-item">
      <span class="item-field">{{ description }}</span>
    </Col>
    <Col span="8" class="c-smart-button">
      <el-select v-model="selectBtn" placeholder="请选择">
        <el-option v-for="item in enumeration" :key="item.key" :value="item.key" :label="item.value"> </el-option>
      </el-select>
      <div v-if="msg" class="c-col-msg">
        <span>{{ msg }}</span>
      </div>
    </Col>
  </Row>
</template>
<script>
import mixinVerify from './mixin-verify'
export default {
  name: 'smartBtn',
  mixins: [mixinVerify],
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    enumeration: {
      type: Array,
      default() {
        return []
      }
    },
    defaultValue: {
      type: [Number, String],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    verify: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    selectBtn: {
      get() {
        return this.value || this.defaultValue
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.$emit('input', this.selectBtn)
  }
}
</script>
<style lang='scss' scoped>
.c-smart-button {
  position: relative;
  z-index: 5;
}

.c-col-msg {
  position: absolute;
  z-index: 4;
  left: 4px;
  bottom: -12px;
  color: #ff4400;
}
</style>
